import * as Sentry from "@sentry/react";
import type { ApiError } from "./fetchClient";

function reportToSentry(error: ApiError) {
	const errorInfo = {
		url: error.config?.url,
		method: error.config?.method,
		headers: error.config?.headers,
	};

	if (error.response) {
		Sentry.captureException(error, {
			tags: {
				type: "api_error",
				status: error.response.status,
			},
			extra: {
				...errorInfo,
				status: error.response.status,
				statusText: error.response.statusText,
				responseData: error.response.data,
			},
		});
	} else if (error.request) {
		Sentry.captureException(error, {
			tags: {
				type: "network_error",
			},
			extra: errorInfo,
		});
	} else {
		Sentry.captureException(error, {
			tags: {
				type: "request_error",
			},
			extra: errorInfo,
		});
	}
}

export function handleApiError(error: ApiError) {
	if (error.response) {
		const status = error.response.status;
		// Only report server errors (5xx) and unexpected client errors to Sentry.
		// Expected client errors (401, 403, 404, 409, 422) are handled by callers.
		const isServerError = status >= 500;
		const isExpectedClientError =
			status === 401 ||
			status === 403 ||
			status === 404 ||
			status === 409 ||
			status === 422;

		if (isServerError || !isExpectedClientError) {
			reportToSentry(error);
		}

		if (isServerError) {
			console.error("api server error", error.response);
		}
	} else {
		// Network errors (no response) — not actionable server-side
		// (user lost connectivity, tab woke up, DNS hiccup, etc.)
		console.warn("network error (not reported to Sentry)", error);
	}
}
